/**
 * The price a job's quote shows on the technician card: the service as the
 * customer is quoted it — EFT buffer in, bundle discount off, diagnostics
 * credit NOT taken off (the invoice refunds that separately) — in both ex and
 * inc GST, because the card is read by staff who may be talking to either a
 * business or a residential customer.
 *
 * `serviceTotalExGst` / `IncGst` are computed by sm4rt-api from the same lines
 * promotion sends. They are null when the list response carried no line items;
 * then the raw stored `total` (ex-GST, no EFT, no discount) is the only figure,
 * and it is labelled ex rather than dressed up with a guessed inc.
 */

import type { QuotesListItem } from '@techgitter/contracts';

const money = (n: number): string => `$${n.toFixed(2)}`;

export function formatQuoteServiceTotal(
  quote: Pick<QuotesListItem, 'total' | 'serviceTotalExGst' | 'serviceTotalIncGst'>,
): string {
  const ex = quote.serviceTotalExGst;
  const inc = quote.serviceTotalIncGst;
  if (ex != null && inc != null) {
    return `${money(ex)} ex / ${money(inc)} inc`;
  }
  return `${money(quote.total)} ex`;
}
